import { useEffect, useState } from 'react'
import type { PlaylistOptions } from '@/components/build/types'

// What an instructor actually teaches -- the builder only offers real combinations.
export function usePlaylistOptions(instructorId: string | null) {
  const [data, setData] = useState<PlaylistOptions | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    setData(null)
    setError(null)
    if (!instructorId) return

    let cancelled = false
    fetch(`/api/playlist_builder/${encodeURIComponent(instructorId)}/options`, { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error(`Request failed: ${response.status}`)
        return response.json() as Promise<PlaylistOptions>
      })
      .then((json) => !cancelled && setData(json))
      .catch((err) => !cancelled && setError(err instanceof Error ? err.message : 'Failed to load options'))
    return () => {
      cancelled = true
    }
  }, [instructorId])

  return { data, error }
}
